

const convertErrorMessage = (error: any) => {
    if (error.status === 400 || error.status === 404) {
        if (error.data.error) {
            return error.data.error;
        }
        if (error.data.non_field_errors) {
            return error.data.non_field_errors[0];
        }
        for (const key in error.data) {
            if (error.data[key]) {
                return error.data[key];
            }
        }
    }
    return "An error occurred";
}

export default convertErrorMessage;
